import { useaxios } from "../../../utils/useaxios";
export default (from, to) => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/sell/summary_sold.php', { from, to }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            if (res.data.length > 0) {
                initDispatch({
                    type: 'setsummary_sell_report', payload: {
                        summary_sell_report: res.data[0].total_sold,
                        summary_sell_profit_report: res.data[0].total_profit

                    }
                });
            }
            settable_type("summary_sell_report");
        }
        // setloading(false);
    });
}